import { GivelifyLabel } from '@givelify/givelify-ui';
import { styled } from '@mui/material/styles';

export const StyledLabel24 = styled(GivelifyLabel)({
    marginBottom: 24,
});

export const StyledLabel16 = styled(GivelifyLabel)({
    marginBottom: 16,
});

export const AddressWrapper = styled('div')({
    border: '1px solid #E3E3E3',
    borderRadius: 8,
    padding: '14px 32px',
    marginTop: 24,
    marginBottom: 8,
    '& > *': {
        lineHeight: '24px',
        '&:not(:first-child)': {
            fontWeight: 400,
        },
    },
});

export const StyledCampusLabel = styled(GivelifyLabel)({
    marginTop: 24,
    marginBottom: 8,
});

export const NicknameWrapper = styled('div')({
    marginTop: 24,
});

export const CheckboxWrapper = styled('div')({
    marginTop: 35,
    marginBottom: 33,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});

export const StyledLink = styled('a')(({ theme }) => ({
    textDecoration: 'none',
    color: theme.legacy.colors?.primary || theme.legacy.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
    '&:active': {
        color:
            theme.legacy.colors?.accentDarkBlue ||
            theme.legacy.palette.primary.dark,
        textDecoration: 'underline',
    },
}));
